module.exports = __webpack_public_path__ + "img/Exchange.7cf93346.svg";